import { Builder } from '@builder.io/react';

import HeroInput from './index';

Builder.registerComponent(HeroInput, {
  name: 'Hero Input',
  inputs: [
    { name: 'title', type: 'string' },
    { name: 'pageName', type: 'string' },
    { name: 'searchSuggestions', type: 'list', subFields: [{ name: 'text', type: 'string' }] },
    {
      name: 'formHiddenFields',
      type: 'list',
      subFields: [
        { name: 'name', type: 'string' },
        { name: 'value', type: 'string' }
      ]
    },
    { name: 'display', type: 'string' },
    {
      name: 'webgl',
      type: 'object',
      subFields: [
        {
          name: 'style',
          type: 'object',
          subFields: [
            { name: '--gradient-color-1', type: 'string' },
            { name: '--gradient-color-2', type: 'string' },
            { name: '--gradient-color-3', type: 'string' },
            { name: '--gradient-color-4', type: 'string' }
          ]
        }
      ]
    }
  ]
});
